import React from 'react';
import { Field, reduxForm } from 'redux-form';
import RaisedButton from 'material-ui/RaisedButton';
import styles from '../../../styles/styles';
import {renderPasswordField} from "../../../services/form";
import withTranslation from "../../../hoc/withTranslation";
import i18n from "i18next";

const validate = (values) => {
    const errors = {};
    const requiredFields = [
        'password',
        'repeat'
    ];

    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = i18n.t('generic.required')
        }
    });

    if (values.password && values.repeat && values.password !== values.repeat) {
        requiredFields.forEach(field => {
            errors[field] = i18n.t('generic.error_password_should_be_identical')
        })
    }

    return errors;
};

const AdminPasswordForm = (props) => {
    const { handleSubmit, pristine, reset, submitting } = props;

    return (
        <form onSubmit={handleSubmit}>
            <div>
                <Field id="password" name="password" component={renderPasswordField} label={props.t('account_page.password')} fullWidth={true}/>
                <Field id="repeat" name="repeat" component={renderPasswordField} label={props.t('account_page.repeat_password')} fullWidth={true}/>
            </div>
            <div style={styles.formButtons}>
                <RaisedButton
                    label={props.t('generic.save')}
                    style={styles.formButton}
                    disabled={pristine || submitting}
                    type="submit"
                    primary={true}
                />

                <RaisedButton
                    style={styles.formButton}
                    label={props.t('generic.reset')}
                    type="button"
                    disabled={pristine || submitting}
                    onClick={reset}
                />
            </div>
        </form>
    );
};

export default reduxForm({
  form: 'editPasswordAdmin',
  validate
})(withTranslation(AdminPasswordForm));



// WEBPACK FOOTER //
// src/components/admin/AdminPasswordForm/AdminPasswordForm.js